import { BaseAlertBanner, BaseButton } from '@components';
import ClientLogo from '@components/logo';
import { BaseTitle } from '@components/typography/styled.ts';
import { useCustomNavigate } from '@hooks/useCustomNavigate.ts';
import FooterLogo from '@layouts/auth/footer-logo';
import { useLingui } from '@lingui/react/macro';
import { ROUTES } from '@router/constants.ts';

import { AuthSharedWrapper, FooterLogoSection, FormSection } from '../___shared___/styled.tsx';
import { AlertSection, SuccessMessageSection } from '../___shared___/styled.tsx';

const RegisterPasswordChangeSuccess = () => {
    const { t } = useLingui();
    const ALERT_BANNER_MSG = t`Your password has been changed successfully.`;

    const navigate = useCustomNavigate();

    return (
        <AuthSharedWrapper>
            <FormSection $maxWidth={424}>
                <ClientLogo />

                <SuccessMessageSection>
                    <BaseTitle>{t`Password changed`}</BaseTitle>
                </SuccessMessageSection>

                <AlertSection>
                    <BaseAlertBanner description={ALERT_BANNER_MSG} />
                </AlertSection>

                <BaseButton
                    onClick={() => {
                        navigate(ROUTES.AUTH.LOGIN);
                    }}
                >
                    {t`Log in`}
                </BaseButton>
            </FormSection>

            <FooterLogoSection>
                <FooterLogo />
            </FooterLogoSection>
        </AuthSharedWrapper>
    );
};

export default RegisterPasswordChangeSuccess;
